import { JobFunction } from '@atlas/types'

// Centralized job-function display labels + selectable options, so the user
// directory, the edit dialog and the people pickers stay consistent. Mirrors
// `roles.ts`, but there is deliberately NO hierarchy here: job functions are
// peers, so nothing orders or compares them the way `roleAtLeast` does roles.

/** Human-readable label for each job function. */
export const JOB_FUNCTION_LABELS: Record<JobFunction, string> = {
	[JobFunction.UNASSIGNED]: 'Unassigned',
	[JobFunction.PM]: 'PM',
	[JobFunction.DESIGNER]: 'Designer',
	[JobFunction.COPYWRITER]: 'Copywriter',
	[JobFunction.REVIEWER]: 'Reviewer',
	[JobFunction.ACCOUNT]: 'Account',
	[JobFunction.DEVELOPER]: 'Developer',
}

/**
 * Selectable job functions for `<select>` controls. `UNASSIGNED` leads because
 * it is the default and the "clear it again" choice; the rest are alphabetical,
 * since no ordering is meaningful between them.
 */
export const JOB_FUNCTION_OPTIONS: ReadonlyArray<{ value: JobFunction; label: string }> = [
	JobFunction.UNASSIGNED,
	...Object.values(JobFunction)
		.filter((value) => value !== JobFunction.UNASSIGNED)
		.sort((a, b) => JOB_FUNCTION_LABELS[a].localeCompare(JOB_FUNCTION_LABELS[b])),
].map((value) => ({ value, label: JOB_FUNCTION_LABELS[value] }))

/** Safe label lookup — an unknown value (an enum added server-side first) shows itself rather than blank. */
export const jobFunctionLabel = (jobFunction: string): string =>
	JOB_FUNCTION_LABELS[jobFunction as JobFunction] ?? jobFunction
